import axios from 'axios';
import { awsUrl, url, newApiBaseUrl, tshuvApi, BaseUrl } from '../../axiosInstance';
import * as actionType from '../store/action'

export const getCoupons = () => {
    return axios.get(`${url}coupons`)
    .then(res => res.data)
    .catch(e => console.log(e))
}


export const createCoupon = (data) => {

    return (
        axios.post(`${url}Coupon/AddCoupon`, data, {
           headers: {
                'Authorization': `bearer ${localStorage.token}`,
                "Access-Control-Allow-Origin": "*",
            },
        }));
};